import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component'
import { BulkTableComponent } from './bulk-table/bulk-table.component'
import { BulkOrderConfirmationComponent } from './bulk-order-confirmation/bulk-order-confirmation.component'
import { BulkOrderModalComponent } from './bulk-order-modal/bulk-order-modal.component'
import { BulkQuoteConfirmationComponent } from './bulk-quote-confirmation/bulk-quote-confirmation.component'
import { BulkOrderCartModalComponent } from './bulk-order-cart-modal/bulk-order-cart-modal.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { DatePickerModule } from '../../shared/components/date-picker/date-picker.module'
import { QuantityCounterModule } from '../../shared/components/quantity-counter/quantity-counter.module'
import { RouterModule } from '@angular/router'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTooltipModule } from '@angular/material/tooltip'

import {
  I18nModule,
  ConfigModule,
  UrlModule,
  provideConfig,
} from '@spartacus/core'
import { MatTabsModule } from '@angular/material/tabs'
import { NgSelectModule } from '@ng-select/ng-select'
import { DIALOG_TYPE } from '@spartacus/storefront'
import { environment } from '../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../config/dialog.config'

@NgModule({
  declarations: [
    BulkOrderConfirmationComponent,
    BulkUploadComponent,
    BulkTableComponent,
    BulkOrderModalComponent,
    BulkQuoteConfirmationComponent,
    BulkOrderCartModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DatePickerModule,
    QuantityCounterModule,
    RouterModule,
    UrlModule,
    I18nModule,
    MatTabsModule,
    NgSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['bulkorder'],
        },
      },
    }),
  ],
  exports: [BulkTableComponent, BulkUploadComponent],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.BULK_ORDER_CART]: {
          inlineRoot: true,
          component: BulkOrderCartModalComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.BULK_ORDER]: {
          inlineRoot: true,
          component: BulkOrderModalComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
})
export class BulkOrderModule {}
